import React from 'react';
import { motion } from 'framer-motion';
export function ChefQuote() {
  return <section className="relative py-24 overflow-hidden" data-id="element-30">
      <div className="absolute inset-0 brick-pattern" data-id="element-31"></div>
      <div className="absolute inset-0 bg-charcoal/80" data-id="element-32"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-34">
          <span className="font-serif text-8xl text-amber/25 leading-none block mb-2" data-id="element-35">
            "
          </span>

          <blockquote className="font-serif text-2xl md:text-3xl lg:text-4xl text-cream leading-relaxed italic -mt-10" data-id="element-36">
            Great food deserves great company — and a great glass of wine.
          </blockquote>

          <div className="mt-10 flex items-center justify-center" data-id="element-37">
            <div className="w-12 h-px bg-amber mr-4" data-id="element-38"></div>
            <div data-id="element-39">
              <p className="text-cream font-medium tracking-wider uppercase text-sm" data-id="element-40">
                Freddie Cheah
              </p>
              <p className="text-gray-500 text-sm mt-1" data-id="element-41">Owner & Chef</p>
            </div>
            <div className="w-12 h-px bg-amber ml-4" data-id="element-42"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}